import { execAdmin } from '@src/apis/reware/utils';
import type {
  BatchDeletePricingRulesMutation,
  BatchDeletePricingRulesMutationVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

/**
 * Batch delete pricing rules by IDs.
 * More efficient than deleting one at a time.
 */
export const batchDeletePricingRules = async ({
  partnerId,
  ruleIds,
}: BatchDeletePricingRulesMutationVariables) => {
  const query = gql`
    mutation batchDeletePricingRules(
      $partnerId: Int!
      $ruleIds: [Int!]!
    ) {
      partner(id: $partnerId) {
        batchDeletePricingRules(ruleIds: $ruleIds) {
          deleted
        }
      }
    }
  `;

  const data = await execAdmin<BatchDeletePricingRulesMutationVariables, BatchDeletePricingRulesMutation>(
    query,
    { variables: { partnerId, ruleIds } }
  );

  const result = data.partner?.batchDeletePricingRules;
  if (!result) {
    throw new Error(
      `batchDeletePricingRules: unexpected response — partner.batchDeletePricingRules is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId})`
    );
  }
  return result;
};
